export const ROOT_PATH = "/";

export const DASHBOARD_PATH = "/dashboard/";
export const REPORTS_CONSTRUCTOR_PATH = "/reports-constructor/";
export const NOT_FOUND_PATH = "/not-found";
